import { Map } from 'immutable';
import Collapsible from 'records/Collapsible';

import {
  COLLAPSIBLES_ADD_COLLAPSIBLE,
  COLLAPSIBLES_KEEP_COLLAPSIBLE,
  COLLAPSIBLES_REMOVE_COLLAPSIBLE,
  COLLAPSIBLES_ADD_COLLAPSIBLE_ITEM,
  COLLAPSIBLES_KEEP_COLLAPSIBLE_ITEM,
  COLLAPSIBLES_TOGGLE_COLLAPSIBLE_ITEM,
  COLLAPSIBLES_OPEN_COLLAPSIBLE_ITEM,
  COLLAPSIBLES_CLOSE_COLLAPSIBLE_ITEM,
} from 'actions/collapsibles';

const initialState = new Map();

const actionsMap = {
  [COLLAPSIBLES_ADD_COLLAPSIBLE]: (state, action) => {
    const newState = state.set(
      action.collapsibleName, new Collapsible({
        allowMultiple: action.allowMultiple,
      })
    );
    return newState;
  },
  [COLLAPSIBLES_KEEP_COLLAPSIBLE]: (state, action) => {
    if(state.get(  action.collapsibleName)!=undefined){
      return state;
    }else{
      const newState = state.set(
        action.collapsibleName, new Collapsible({
          allowMultiple: action.allowMultiple,
        })
      );
      return newState;
    }
  },
  [COLLAPSIBLES_REMOVE_COLLAPSIBLE]: (state, action) => {
    return state.delete(action.collapsibleName);
  },
  [COLLAPSIBLES_ADD_COLLAPSIBLE_ITEM]: (state, action) => {
    let collapsiblesData = state.getIn([action.collapsibleName, 'collapsibleItems']);
    collapsiblesData = collapsiblesData.set(
      `${ action.itemKey }`, true
    );
    return state.setIn([action.collapsibleName, 'collapsibleItems'], collapsiblesData);
  },
  [COLLAPSIBLES_KEEP_COLLAPSIBLE_ITEM]: (state, action) => {
    let collapsiblesData = state.getIn([action.collapsibleName, 'collapsibleItems']);
    if(collapsiblesData.get(  `${ action.itemKey }`)!=undefined){
      return state;
    }else{
      collapsiblesData = collapsiblesData.set(
        `${ action.itemKey }`, true
      );
      return state.setIn([action.collapsibleName, 'collapsibleItems'], collapsiblesData);
    }
  },
  [COLLAPSIBLES_TOGGLE_COLLAPSIBLE_ITEM]: (state, action) => {
    let collapsible = state.get(action.collapsibleName);
    if (collapsible.get('allowMultiple')) {
      collapsible = collapsible.set(
        'collapsibleItems', collapsible.toggleCollapsibleItem(`${ action.itemKey }`)
      );
      return state.set(action.collapsibleName, collapsible);
    }
    collapsible = collapsible.set(
      'collapsibleItems', collapsible.toggleSingleItemCollapsible(`${ action.itemKey }`)
    );
    return state.set(action.collapsibleName, collapsible);
  },
  [COLLAPSIBLES_OPEN_COLLAPSIBLE_ITEM]: (state, action) => {
    let collapsible = state.get(action.collapsibleName);
    if (collapsible.get('allowMultiple')) {
      collapsible = collapsible.set(
        'collapsibleItems', collapsible.openCollapsibleItem(`${ action.itemKey }`)
      );
      return state.set(action.collapsibleName, collapsible);
    }
  },
  [COLLAPSIBLES_CLOSE_COLLAPSIBLE_ITEM]: (state, action) => {
    let collapsible = state.get(action.collapsibleName);
    if (collapsible.get('allowMultiple')) {
      collapsible = collapsible.set(
        'collapsibleItems', collapsible.closeCollapsibleItem(`${ action.itemKey }`)
      );
      return state.set(action.collapsibleName, collapsible);
    }
  },
};

export default function collapsibles(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
